module.exports = __webpack_public_path__ + "img/logo.0fb1a8e1.png";